import { useLocation } from 'react-router';
import { Blocks, Building2, LayoutGrid, MessageSquare, Users } from 'lucide-react';
import {
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
} from '@/components/ui/sidebar';
import { SidebarFrame } from '@/components/sidebar-frame';
import { SidebarNav, type SidebarNavItem } from '@/components/sidebar-nav';

/**
 * Super-admin sidebar — same SidebarFrame as workspace/org, no switcher. The
 * four operator sections. Replaces the former hand-rolled <aside> in
 * super-admin-layout.tsx.
 */
export function SuperAdminSidebar() {
  const location = useLocation();
  const path = location.pathname;

  const items: SidebarNavItem[] = [
    {
      icon: <Building2 className="size-4" />,
      label: 'Organizations',
      to: '/super-admin/organizations',
      isActive: path.startsWith('/super-admin/organizations'),
    },
    {
      icon: <LayoutGrid className="size-4" />,
      label: 'Workspaces',
      to: '/super-admin',
      // Index route — exact match only (so /super-admin/channels doesn't light it).
      isActive: path === '/super-admin',
    },
    {
      icon: <MessageSquare className="size-4" />,
      label: 'Channels',
      to: '/super-admin/channels',
      isActive: path.startsWith('/super-admin/channels'),
    },
    {
      icon: <Users className="size-4" />,
      label: 'Users',
      to: '/super-admin/users',
      isActive: path.startsWith('/super-admin/users'),
    },
    {
      icon: <Blocks className="size-4" />,
      label: 'Meta Apps',
      to: '/super-admin/meta-apps',
      isActive: path.startsWith('/super-admin/meta-apps'),
    },
  ];

  return (
    <SidebarFrame>
      <SidebarHeader className="h-12 !p-0 border-b">
        <div className="flex h-12 w-full items-center gap-2 px-4">
          <div className="flex size-8 items-center justify-center rounded-md bg-primary text-primary-foreground text-sm font-semibold shrink-0">
            SA
          </div>
          <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
            <span className="truncate font-semibold">Super Admin</span>
            <span className="truncate text-xs text-muted-foreground">Operator</span>
          </div>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarMenu className="pt-2">
          <SidebarNav items={items} />
        </SidebarMenu>
      </SidebarContent>
    </SidebarFrame>
  );
}
